export type SubApp = "global" | "core-app-onboarding";
export type QueryString = { [key: string]: string };

/**
 * This service should be the one true source to handle navigation logic between Vue apps.
 * The SubApp type needs to track the possible key names for sub-apps, which needs to match
 * the possible values for the env variable VUE_APP_BUILD_TYPE described on vue.config.js
 */
export class RoutingService {
  private GLOBAL_APP_BASE_URL = process.env.VUE_APP_APP_URL;
  private GLOBAL_HOST_NAME = process.env.VUE_APP_BASE_DOMAIN;
  private IS_LOCAL_DEV = process.env.NODE_ENV !== "production";

  /**
   * This function simplifies navigation between Apps with-in the repo.
   * Choose a path and subapp to navigate to and the URL will be built based on
   * environemnt context.
   * @param path The path portion of a URL. Should alway start with "/"
   * @param subApp The key name for a sub app. Values are delimited by SubApp type
   * @param query A regular key-value json limited to string values for a URL query
   */
  public navigate(
    path: string,
    subApp: SubApp = "global",
    query: QueryString | null = null
  ): void {
    let newLocation = "";
    if (subApp === "global" || this.IS_LOCAL_DEV) {
      newLocation = `${this.GLOBAL_APP_BASE_URL}${path}`;
    } else {
      newLocation = `https://${subApp}.${this.GLOBAL_HOST_NAME}${path}`;
    }

    if (typeof query !== null) {
      const queryString = new URLSearchParams(query as QueryString).toString();
      newLocation += `?${queryString}`;
    }

    window.location.href = newLocation;
  }
}
